import React from "react";
import "./App.css";
import MarketWidget from "./Components/MarketWidget";

function App() {
  return (
    <div className="App">
      <MarketWidget />
    </div>
  );
}

export default App;
